// extracted by mini-css-extract-plugin
module.exports = {"editedEssay":"style-module__editedEssay___1EziK","popover":"style-module__popover___69l3z"};